import type {
  IPluginLoadTelemetryRepository,
  PluginLoadEvent,
} from '@/domain/repositories/IPluginLoadTelemetryRepository';
import type { DeviceSession } from '@/domain/entities/DeviceSession';

/**
 * Use case responsável por registrar a telemetria de carregamento de plugin
 * (HUB-237, CA-13/CA-14/CA-21) em `POST /plugin-load-events`. Centraliza a
 * política "nunca propaga erro" (CA-21) num único lugar da camada de
 * aplicação — mesmo padrão de `EnqueueLeadUseCase.logStorageError`: erro
 * estruturado em `console.error`, nunca exposto em UI nem relançado. Falha
 * ao registrar o log nunca interrompe o fluxo de retry/render do plugin
 * (CA-13/CA-14 continuam válidas independente do sucesso desta chamada).
 */
export class RecordPluginLoadEventUseCase {
  constructor(private readonly repository: IPluginLoadTelemetryRepository) {}

  async execute(session: DeviceSession, event: PluginLoadEvent): Promise<void> {
    try {
      await this.repository.record(session, event);
    } catch (error) {
      console.error(
        '[RecordPluginLoadEventUseCase] Falha ao registrar telemetria de carregamento de plugin — melhor esforço, sem impacto no fluxo (CA-21).',
        {
          activationType: event.activationType,
          success: event.success,
          error: error instanceof Error ? error.message : String(error),
        }
      );
    }
  }
}
